export class ConfigurationManager {
    public static isModifyRegionOnlyMode: boolean = false;
    public static isPathRegionEnabled: boolean = false;
    public static isMaskEnabled: boolean = false;
}
